<template>
  <div>
    <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
      <v-layout wrap class="primary white--text" px-2>
        <v-flex xs4>
          <v-layout wrap justify-space-between>
            <v-flex>
              <v-btn @click="addExperience" x-small outlined class="white" :class="{ 'secondary white--text': dossier.profile.experiences.length === 0 }" elevation="0">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>
                {{ $t('c') }}
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn @click="isShowingReorderExperiencesDialog = true" x-small outlined class="white" elevation="0" v-if="dossier.profile.experiences.length >= 2">
                <v-icon x-small class="mr-1">mdi-arrow-split-horizontal</v-icon>
                {{ $t('e') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4 text-center>
          <h3>
            <span>{{ $t('d') }}</span>
            <v-icon small class="ml-2 primary--text">mdi-pen</v-icon>
          </h3>
        </v-flex>
        <v-flex xs4 text-end>
          <div v-if="!isFromToken">
            <v-btn @click="isShowingStartOverDialog = true" x-small outlined class="white secondary white--text" elevation="0">
              <v-icon x-small class="mr-1">mdi-refresh</v-icon>
              <span>{{ $t('e2') }}</span>
              <!-- <v-chip color="orange" class="white--text ml-2" x-small link><v-icon class="mr-1" x-small>mdi-shimmer</v-icon>Nouveau</v-chip> -->
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-banner>
    <v-layout wrap>
      <v-flex xs12>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout wrap v-for="(experience, index) in dossier.profile.experiences" :key="index" :id="`view-experiences-${index}`">
              <v-hover v-slot="{ hover }">
                <v-flex xs12 :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editExperience(index)">
                  <v-layout wrap>
                    <v-flex xs3 class="leftCell" pl-1>
                      <b>{{ $t('f') }} {{ index + 1 }}</b>
                      <v-icon v-if="hover" small class="ml-2">mdi-pen</v-icon>
                    </v-flex>
                    <v-flex xs9>
                      <view-experience :experience="experience" />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-hover>
              <v-flex xs12>
                <v-divider class="primary"/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="dossier.profile.experiences.length === 0">
              <v-flex xs3>
              </v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('n') }}</i>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isShowingReorderExperiencesDialog" persistent v-if="isShowingReorderExperiencesDialog" width="80%">
      <v-card class="pa-6">
        <v-layout wrap>
          <v-flex xs12>
            <div class="mb-6 text-center">
              <h3>{{ $t('a') }}</h3>
              <small>{{ $t('b') }}</small>
            </div>
            <reorder-experiences :experiences="dossier.profile.experiences" @updateExperiencesOrder="updateExperiencesOrder"/>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingStartOverDialog" width="80%" height="95vh">
      <v-card>
        <start-over-experiences :dossier="dossier" :cvPdfUrl="cvPdfUrl" :cvPagesNb="cvPagesNb" @setIsShowingStartOverDialog="setIsShowingStartOverDialog"/>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import ReorderExperiences from '@/components/profile/ReorderExperiences'
import StartOverExperiences from '@/components/profile/StartOverExperiences'
import ViewExperience from '@/components/profile/ViewExperience'
import { mapGetters } from "vuex";

export default {
  components: {
    ReorderExperiences,
    StartOverExperiences,
    ViewExperience
  },
  props: {
    dossier: Object,
    cvPdfUrl: String,
    cvPagesNb: Number,
    isConsultant: Boolean,
    isFromToken: Boolean
  },
  data: () => ({
    isShowingReorderExperiencesDialog: false,
    isShowingStartOverDialog: false,
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    addExperience() {
      this.dossier.profile.experiences.push({
        startDate: "",
        endDate: "",
        company: "",
        title: "",
        location: "",
        description: "",
        technicalEnv: ""
      })

      setTimeout(() => {
        const newElt = document.getElementById(`view-experiences-${this.dossier.profile.experiences.length - 1}`)
        // Scroll to new element
        newElt.scrollIntoView({behavior : "smooth", block: "center" })
        // Make the last item edited flash in green for a small time
        setTimeout(() => {
          const originalBackgroundColor = newElt.style.backgroundColor
          newElt.style.backgroundColor = 'rgba(0, 200, 83, 0.3)'
          setTimeout(() => {
            newElt.style.backgroundColor = originalBackgroundColor
          }, 1200)
        }, 500)
      })
    },
    editExperience(index) {
      this.$emit('setFieldPath', { fieldPath: ['experiences', index], savedScrollEltId: `view-experiences-${index}` })
    },
    updateExperiencesOrder(newExperiences) {
      this.dossier.profile.experiences = JSON.parse(JSON.stringify(newExperiences))
      this.isShowingReorderExperiencesDialog = false
    },
    setIsShowingStartOverDialog(data) {
      this.isShowingStartOverDialog = data.isShowingStartOverDialog
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "a": "Réordonner les expériences",
    "b": "Réorganisez les expériences dans l'ordre que vous souhaitez.",
    "c": "Ajouter",
    "d": "Expériences",
    "e": "Réordonner",
    "e2": "Expériences mal extraites ?",
    "f": "Expérience",
    "n": "Aucune expérience."
  },
  "en": {
    "a": "Re-order the experiences",
    "b": "Sort the experiences the way you want.",
    "c": "Add",
    "d": "Experiences",
    "e": "Re-order",
    "e2": "Experiences badly extracted ?",
    "f": "Experience",
    "n": "No experience."
  }
}
</i18n>